import { render } from "./HeroiconsOutlineFolderRemove.vue?vue&type=template&id=12384f4e"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFolderRemove.vue"]])

export default __exports__